import { useEffect } from "react";
import Lottie from "lottie-web";

const useAnimation = ({
  container,
  animationData,
  assetsPath,
  loop = false,
  autoplay = false,
}) => {
  useEffect(() => {
    const _container = document.querySelector(container);

    const lottie = Lottie.loadAnimation({
      container: _container,
      animationData,
      assetsPath,
      renderer: "svg",
      loop,
      autoplay,
    });

    _container.addEventListener("sal:in", () => {
      lottie.play();
    });
  }, []);
};

export default useAnimation;
